import React, { Component } from 'react';
import './App.css';

class App extends Component {
  render() {
    return (
      <div className="app">
        <header className="app-header">
          <a className="logo">shub.ca/</a>
          <div className="nav">
            <a className="navLink">/about</a>
            <a className="navLink">/work</a>
            <a className="navLink">/contact</a>
          </div>
        </header>
        <div className="app-content">
          <section className="intro">
            <h1>shub sengupta is&nbsp;a <span className="emphasis">digital&nbsp;designer</span> &amp; <span className="emphasis">web&nbsp;developer</span> usually located in kitchener-waterloo, canada.</h1>
          </section>
          <p>more to come...</p>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js